module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'accordion-group\'>\n    <div class=\'accordion-heading\'>\n        <div class=\'accordion-toggle\'>\n            <div class=\'svg_icon\'>\n                ' +
((__t = ( WiseMetering.icon('list') )) == null ? '' : __t) +
'\n            </div>\n            <dt>' +
((__t = ( i18next.t('glossary.tenants') )) == null ? '' : __t) +
':</dt>\n        </div>\n    </div>\n    <div class=\'accordion-body\'>\n        <div class=\'accordion-inner\' id=\'tenants\'></div>\n    </div>\n</div>\n';

}
return __p
}